import { Card, CardContent, CardHeader } from '@/shared/components/ui/card';
import { Skeleton } from '@/shared/components/ui/skeleton';

export const KPICardSkeleton = () => {
  return (
    <Card className="h-64 shrink-0 justify-between" variant="information">
      <CardHeader>
        <div className="flex flex-row items-center justify-between space-x-4">
          {/* Header Content */}
          <div className="flex-1">
            <Skeleton className="mb-2 h-6 w-32" />
            <Skeleton className="h-4 w-24" />
          </div>

          {/* Tendency Highlighter */}
          <div className="flex flex-col items-center space-y-1">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-6 w-6 rounded-full" />
          </div>

          {/* Actions Dropdown */}
          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      </CardHeader>

      <CardContent>
        {/* Main Content */}
        <Skeleton className="mb-2 h-12 w-20" />
        <Skeleton className="mb-4 h-5 w-24" />

        {/* Footer Content */}
        <div className="flex flex-col">
          <div className="ml-auto">
            <Skeleton className="mb-1 h-5 w-16" />
            <Skeleton className="h-4 w-20" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
